import * as React from 'react';
import * as ReactDOMServer from 'react-dom/server';
import { IMap, IPlacemark, IYmaps, YmapsCoords } from '../../../browser/ymaps/types';
import { TPinObject } from '../../types/map';
import { MapPreview } from './components/map_preview/map_preview';
import { pinGK } from './components/pin-gk';
import { ymaps } from './ymaps';

const MAX_ZOOM = 16;
const GK_PIN_ICON_SIZE = [46, 55];
const GK_PIN_SHADOW_WIDTH = 8;

const YModules = [
  'Map',
  'Placemark',
  'geoObject.addon.balloon',
  'templateLayoutFactory',
  'control.ZoomControl',
  'layout.ImageWithContent',
];

const MAP_OPTIONS = {
  controls: ['zoomControl'],
  maxZoom: MAX_ZOOM,
  zoom: 9,
};

export class MapContainer {
  private ymaps: IYmaps;
  private placemarks: IPlacemark[] = [];
  public map: IMap;

  public constructor() {}

  public initialize = (mapId: string, center: [number, number]) => {
    return ymaps.loadYmaps(YModules).then(ymaps => {
      this.ymaps = ymaps;
      this.map = new ymaps.Map(
        mapId,
        {
          ...MAP_OPTIONS,
          center,
        },
        {
          maxZoom: MAX_ZOOM,
        },
      );
    });
  };

  public createPlacemark = (mapObject: TPinObject) => {
    if (
      mapObject.coordinates === undefined ||
      mapObject.coordinates.lng === undefined ||
      mapObject.coordinates.lat === undefined
    ) {
      return;
    }

    const coords = [mapObject.coordinates.lat, mapObject.coordinates.lng] as YmapsCoords;
    const placemark = new this.ymaps.Placemark(
      coords,
      {
        balloonContent: ReactDOMServer.renderToStaticMarkup(<MapPreview {...mapObject} />),
      },
      {
        balloonOffset: [0, -GK_PIN_ICON_SIZE[1] + GK_PIN_SHADOW_WIDTH],
        hideIconOnBalloonOpen: false,
        iconContentLayout: this.ymaps.templateLayoutFactory.createClass(pinGK),
        iconImageHref: '',
        iconLayout: 'default#imageWithContent',
        iconOffset: [-GK_PIN_ICON_SIZE[0] / 2, -GK_PIN_ICON_SIZE[1] + GK_PIN_SHADOW_WIDTH] as [number, number],
        iconShape: {
          coordinates: [GK_PIN_ICON_SIZE[0] / 2, (GK_PIN_ICON_SIZE[0] - GK_PIN_SHADOW_WIDTH) / 2],
          radius: GK_PIN_ICON_SIZE[0] / 2 - GK_PIN_SHADOW_WIDTH,
          type: 'Circle',
        },
        iconSize: GK_PIN_ICON_SIZE as [number, number],
      },
    );

    this.placemarks.push(placemark);
    this.map.geoObjects.add(placemark);
  };

  public createPlacemarks = (mapObjects: TPinObject[]) => {
    mapObjects.forEach(this.createPlacemark);
  };

  public removeAllPlacemarks = () => {
    this.map.geoObjects.removeAll();
  };

  public updatePlacemarks = (mapObjects: TPinObject[]) => {
    if (!this.map) {
      return;
    }

    this.removeAllPlacemarks();
    this.createPlacemarks(mapObjects);
  };

  public disable = (behavior: string): void => {
    this.map.behaviors.disable(behavior);
  };

  public fitToPins = async () => {
    try {
      await this.map.setBounds(this.map.geoObjects.getBounds(), { checkZoomRange: true });
      // почему-то для одного пина некорректно отрабатывает checkZoomRange
      // поэтому проверяем зум после setBounds и выставляем тот, который нужен
      // istanbul ignore next
      if (this.map.getZoom() > MAX_ZOOM) {
        this.map.setZoom(MAX_ZOOM);
      }
    } catch (err) {
      console.error(err);
    }
  };
}
